/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import WarehouseSyncModel from 'cio/models/warehouse-sync';
import {
  getWarehouseDestinationImageSrc,
  getWarehouseDestinationName,
  WarehouseDestination,
  WarehouseDestinationID,
} from 'cio/utils/warehouse';

interface WarehouseSyncListStatusArgs {
  model?: WarehouseSyncModel;
}

const DESTINATIONS: WarehouseDestination[] = [
  WarehouseDestinationID.s3,
  WarehouseDestinationID.gcs,
  WarehouseDestinationID.azure,
];

export default class WarehouseSyncListStatus extends Component<WarehouseSyncListStatusArgs> {
  get options() {
    let options = DESTINATIONS.map((type) => {
      return {
        type,
        icon: getWarehouseDestinationImageSrc(type),
        label: getWarehouseDestinationName(type),
        isEnabled: this.args.model?.type === type,
      };
    });

    // If any integration is enabled, the rest should be hidden.
    if (options.any((opt) => opt.isEnabled)) {
      options = options.filter((opt) => opt.isEnabled);
    }

    return options;
  }
}
